
import { Component, Vue } from 'vue-property-decorator';

import axios from 'axios';
import Swal from 'sweetalert2';

@Component
export default class ReportCoverPage extends Vue {
  private companyName: string | null = null;

  private created(): void {
    this.getCompanyName();
  }

  private getCompanyName(): void {
    const url: string = `${process.env.VUE_APP_AUTH_API_HOST}/companies/name`;
    const accessToken: string = (this as any).$route.query.token;
    axios.get(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }).then((response) => {
      this.companyName = response.data;
    }).catch((error) => {
      Swal.fire({
        title: 'Error Getting Company Name',
        text: `Error: ${error.message}`,
        type: 'error',
      });
    });
  }
}
